module.exports = __webpack_public_path__ + "img/slideshow_6.4d1c7996.jpg";